module.exports = __webpack_public_path__ + "static/media/deep_5450.png.22004805.webp";